import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { Popover, PopoverAnchor, PopoverContent } from '@/components/ui/popover'

export type ContactType = 'call' | 'meeting' | 'email'

/**
 * "Hoe had je contact?" (design §4.10, ED-53): ticking a contact-rhythm task asks first. A type opens
 * the composer of the relation (logging the contact meets the rhythm and ticks the task off);
 * "Alleen afvinken" completes the task without an activity.
 */
export function ContactRhythmPopover({
  open,
  onOpenChange,
  anchor,
  onLog,
  onTickOnly,
  onInspreken,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  anchor: ReactNode
  onLog: (type: ContactType) => void
  onTickOnly: () => void
  /** spec-63 E7: speak the report in; the task stays open. Absent when Inspreken is not available. */
  onInspreken?: (() => void) | undefined
}) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverAnchor asChild>{anchor}</PopoverAnchor>
      <PopoverContent align="start" className="w-72 p-3">
        <p className="mb-2 text-sm font-semibold">Hoe had je contact?</p>
        <div className="flex flex-wrap gap-2">
          <Button type="button" size="sm" variant="outline" onClick={() => onLog('call')}>
            Gesprek
          </Button>
          <Button type="button" size="sm" variant="outline" onClick={() => onLog('meeting')}>
            Meeting
          </Button>
          <Button type="button" size="sm" variant="outline" onClick={() => onLog('email')}>
            E-mail
          </Button>
          {onInspreken ? (
            <Button type="button" size="sm" variant="outline" onClick={onInspreken}>
              Inspreken
            </Button>
          ) : null}
          <Button type="button" size="sm" variant="ghost" onClick={onTickOnly}>
            Alleen afvinken
          </Button>
        </div>
        <p className="mt-2 text-xs text-muted-foreground">Kies je een type, dan opent het vastleggen met datum vandaag.</p>
      </PopoverContent>
    </Popover>
  )
}
